import { atom } from 'recoil';
import { accountHolderSelector } from '../selectors/accountHolderSelector';
import type { AccountDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/account/';

export const accountHolderAtom = atom<AccountDTO>({
    key: 'accountHolder',
    default: accountHolderSelector
});
